import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { InputViewModel } from '../../../Models/TrendViewModel';

@Component({
    selector: 'app-trend-input',
    templateUrl: './trend-input.component.html',
    styleUrls: ['./trend-input.component.css'],
    standalone: false
})
export class TrendInputComponent implements OnInit
{
  @Input()
  public Input: string;
  @Output()
  public InputChange = new EventEmitter<string>();
  @Input()
  public Inputs: InputViewModel[] = [];

  inputNumber: number = 0;
  inputString: string = "";

  ngOnInit() {
    this.initData();
  }

  getMaxInputNumber() {
    let input = this.Inputs.find(i => i.Id == this.inputString);
    if (!input) return 0;
    return input.AvailableNumbers;
  }

  onSelectChange(event:Event) {
    const input = event.target as HTMLInputElement;

    this.inputString = input.value;
    this.onDataChange();
  }
  onInputChange(s) {
    this.inputNumber = parseInt(s, 10);
    this.onDataChange();
  }

  initData() {
    /*let matches = this.Input.match(/\d+$/);
    if (matches) {
      this.inputNumber = parseInt(matches[0]);
      if (!this.inputNumber || isNaN(this.inputNumber) || !isFinite(this.inputNumber))
        this.inputNumber = 0;
      this.inputString = this.Input.replace(matches[0], "")
    }
    else*/
      this.inputString = this.Input;
  }
  onDataChange()
  {
    this.InputChange.emit(this.inputString);

    /*if (!this.getMaxInputNumber())
      this.InputChange.emit(this.inputString);
    else {
      this.inputNumber = Math.max(0, Math.min(this.inputNumber, this.getMaxInputNumber()));
      this.InputChange.emit(this.inputString + this.inputNumber);
    }*/
  }
}
